// removed by extract-text-webpack-plugin
module.exports = {"DailySchedule":"DailySchedule","schoolLogo":"schoolLogo","schedule-header":"schedule-header","scheduleTitle":"scheduleTitle","schedule-content":"schedule-content","columnHeader":"columnHeader","row":"row","date-li":"date-li","lesson-li":"lesson-li","border":"border","changeDay":"changeDay","icon-left-dir":"icon-left-dir","icon-right-dir":"icon-right-dir"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/ScheduleDisplayer/DailySchedule.scss
// module id = orVH
// module chunks = 0